import Scorecard from "@/features/Scores/Scorecard";
import Score from "@/features/Scores/Score";

export default class ScorecardRequestModel {
    constructor(scorecard: Scorecard) {
        this.scores = [];
        scorecard.sections.forEach(section => this.scores.push(...section.scores.map(score => new ScorecardScoreRequestModel(score))));

        this.assessmentDate = scorecard.assessmentDate;
    }

    assessmentDate: Date = new Date();
    scores: ScorecardScoreRequestModel[] = [];
}

// Request model for a score that is specifically part of a scorecard
export class ScorecardScoreRequestModel {
    constructor(score: Score) {
        this.id = score.id;
        this.optionSelectValue = score.optionSelectValue;
        this.minMaxValue = score.minMaxValue;
        this.isSkipped = score.isSkipped;
    }

    id: string | null = null;
    optionSelectValue: string | null = null;
    minMaxValue: number | null = null;
    isSkipped: boolean = false;
}
